import 'bootstrap/dist/css/bootstrap.css';
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {history, pages} from './configureHistory'
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./App.store";
import {Router} from "react-router";
import {ai} from "./TelemetryService";
ai.initialize({history: history},process.env.NODE_ENV==='production'?false:true);

const appContainer = document.getElementById("root");

const store = configureStore(undefined);

//On a refresh, restore the order link before anything renders. Only FirstPage can load an
//order, and the later pages don't carry the link code in their location state. A URL that
//names a link code is left alone, so opening another order's link in the same tab works.
if(sessionStorage) {
    const reqID = sessionStorage.getItem('reqID');
    const page = history.location.pathname.split('/')[1];
    if(reqID && (!page || pages.includes(page)))
        history.push({pathname: `/${reqID}`});
}

// If the app container is present then render the app.
if (appContainer) {
    ReactDOM.render(

        <Provider store={store}>
            <Router history={history}>
                <App/>
            </Router>
        </Provider>,
        appContainer
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
